import { useQuery } from 'convex/react';
import { api } from '@aeon-karaoke/cloud-convex';
import type { Id } from '@aeon-karaoke/cloud-convex/_generated/dataModel';

/** The first lines of a track's words and how many there are, for the
 * lyrics panel. Undefined while loading. */
export function useLyricsPreview(trackId: Id<'tracks'> | undefined) {
  return useQuery(api.tracks.lyricsPreview, trackId ? { trackId } : 'skip');
}
